import { isViewed as isViewedCluster } from '../../../../browser/utils/viewedClusters';
import { CLUSTER_PINS_GRID_MAX_COUNT } from '../../constants/clusterPinsGrids';
import { ICluster } from '../../repositories/dailyrent/entities/cluster/Cluster';
import { IFeaturesMap } from '../../types/map';

// В посутке не используются кластера, объединенные в одну точку на карте,
// вместо этого кластер раскрывается в сетку пинов («ромашку») вокруг своей точки.
// Здесь создаются зум-независимые фичи: geometry у всех пинов кластера = центр кластера,
// фактические координаты пина рассчитываются в рантайме (expandClusterPinFeature)
// по pinIndex/pinsCount, текущему зуму и лимиту устройства (на мобвебе рисуются не все пины).
export function convertClustersToFlatFeaturesMap(clusters: ICluster[]): IFeaturesMap {
  return (
    clusters?.reduce<IFeaturesMap>((result, cluster) => {
      const { coordinates, geohash, offers } = cluster;
      const visibleOffers = offers?.slice(0, CLUSTER_PINS_GRID_MAX_COUNT) ?? [];

      visibleOffers.forEach((offer, index) => {
        // разделитель защищает от коллизий вида 'abc'+'12' === 'abc1'+'2' (geohash — base32, без '_')
        const newGeohash = index === 0 ? geohash : `${geohash}_${index}`;

        result[newGeohash] = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [coordinates.lat, coordinates.lng],
          },
          id: newGeohash,
          properties: {
            ...cluster,
            geohash: newGeohash,
            pinIndex: index,
            pinsCount: visibleOffers.length,
            offers: [{ ...offer, isViewed: offer.isViewed || isViewedCluster(offer.cianId) }],
          },
        };
      });

      return result;
    }, {}) ?? {}
  );
}
